import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import el from 'vuetify/es5/locale/el'
import en from 'vuetify/es5/locale/en'
import overrideTheme from '@/app-theme/plugins/vuetifyTheme.js'

Vuetify.config.silent = import.meta.env.MODE === 'production' || false

Vue.use(Vuetify)

export default new Vuetify({
  rtl  : false,
  theme: {
    disable: overrideTheme?.theme?.disable ?? false,
    dark   : overrideTheme?.theme?.dark ?? false,
    options: {
      cspNonce        : undefined,
      minifyTheme     : undefined,
      themeCache      : undefined,
      customProperties: true,
      variations      : true,
      ...(overrideTheme?.theme?.options || {})
    },
    themes: {
      dark: {
        anchor   : '#1976d2',
        primary  : '#1976D2',
        secondary: '#424242',
        accent   : '#82B1FF',
        error    : '#FF5252',
        info     : '#2196F3',
        success  : '#4CAF50',
        warning  : '#FB8C00',
        ...(overrideTheme?.theme?.themes?.dark || {})
      },
      light: {
        anchor   : '#2196F3',
        primary  : '#2196F3',
        secondary: '#424242',
        accent   : '#FF4081',
        error    : '#FF5252',
        info     : '#2196F3',
        success  : '#4CAF50',
        warning  : '#FB8C00',
        ...(overrideTheme?.theme?.themes?.light || {})
      }
    }
  },
  lang: {
    current: import.meta.env.VITE_I18N_LOCALE,
    locales: {
      el,
      en
    }
  },
  icons: {
    iconfont: overrideTheme?.icons?.iconfont ?? 'mdi',
    values  : {
      ...(overrideTheme?.icons?.values || {})
    }
  },
  breakpoint: {
    mobileBreakpoint: overrideTheme?.breakpoint?.mobileBreakpoint ?? 1264,
    scrollBarWidth  : overrideTheme?.breakpoint?.scrollBarWidth ?? 16,
    thresholds      : {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
      ...(overrideTheme?.breakpoint?.thresholds || {})
    }
  }
})
